import request from "./../utils/request";

export function getTags(type = "contact") {
    return request({
        url: `/tags?type=${type}`,
        method: "get",
    });
}

export function createTag(data) {
    return request({
        url: "/tags",
        method: "post",
        data: data,
    });
}

export function updateTag(data) {
    return request.patch(`/tags`, data);
}

export function deleteTag(id) {
    return request.delete(`/tags/${id}`);
}
